export function startOfDayLocal(date: Date): Date {
  const result = new Date(date)
  result.setHours(0, 0, 0, 0)
  return result
}

export function endOfDayLocal(date: Date): Date {
  const result = new Date(date)
  result.setHours(23, 59, 59, 999)
  return result
}

export function toUtcIso(date: Date): string {
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString()
}

export function defaultDateRange(): { start: Date; end: Date } {
  const end = new Date()
  const start = new Date(end.getTime() - 2880 * 60 * 1000)
  return { start, end }
}

export function fromUtcToLocalString(value: string | null | undefined): string {
  if (!value) return ''
  return new Date(value).toLocaleString()
}
